module.exports = __webpack_public_path__ + "img/tag6.ce0d4125.png";